import React from "react";
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { TradingChartData } from "@/shared/types/chart-risk";
import { formatCompactUsd, formatUsd } from "@/shared/utils/format";

import { LINE_CHART_MARGIN_PARAMS_PX } from "../constants";
import { ChartWrapper } from "../styled/chart-wrapper";
import { camelCaseToFlat } from "../utils/camel-case-to-flat";
import { getFormatDate } from "../utils/get-format-date";
interface Props {
  data?: TradingChartData;
}

export function TradingVolumesChart({ data }: Props) {
  const displayData = data?.map((point) => ({
    ...point,
    sellVolume: -point.sellVolume,
  }));
  return (
    <ChartWrapper>
      <ResponsiveContainer>
        <ComposedChart
          data={displayData}
          margin={{ ...LINE_CHART_MARGIN_PARAMS_PX, left: 0 }}
        >
          <YAxis
            tickLine={false}
            yAxisId="left"
            orientation="left"
            tickFormatter={formatCompactUsd}
          />
          <XAxis dataKey="timestamp" tickFormatter={getFormatDate()} />
          <CartesianGrid strokeDasharray="3 3" />
          <ReferenceLine y={0} stroke="var(--fill-primary)" yAxisId="left" />
          <YAxis
            yAxisId="right"
            orientation="right"
            tickFormatter={formatCompactUsd}
          />
          <Tooltip
            labelFormatter={getFormatDate()}
            formatter={(value, name: keyof TradingChartData[number]) => {
              return [
                typeof value === "number" && formatUsd(Math.abs(value)),
                camelCaseToFlat(name),
              ];
            }}
          />
          <Bar
            yAxisId="left"
            dataKey="sellVolume"
            fill="var(--fill-negative)"
          />
          <Bar yAxisId="left" dataKey="buyVolume" fill="var(--fill-positive)" />
          <Line
            type="monotone"
            dataKey="closePrice"
            yAxisId="right"
            stroke="#6c6ca8"
            dot={<span />}
          />
          <Legend formatter={camelCaseToFlat} />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
}
